import { useState } from 'react';
import { cn } from 'shared-ui';
import { getInitials } from '@/utils/avatarUtils';

export interface UserInfoProps {
    name: string;
    email: string;
    avatarUrl?: string;
    className?: string;
}

export function UserInfo({ name, email, avatarUrl, className }: UserInfoProps) {
    const [failedSrc, setFailedSrc] = useState<string | null>(null);

    return (
        <div
            className={cn(
                'flex items-center gap-3 rounded-md border p-2',
                // Collapsed: strip outer border/padding, centre the avatar within the sidebar column
                'group-data-[collapsible=icon]:w-full group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:gap-0 group-data-[collapsible=icon]:border-0 group-data-[collapsible=icon]:p-0',
                className,
            )}
        >
            <div
                className={cn(
                    'border-border bg-muted flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-sm border p-1',
                    // Collapsed: match OrbitIconWrapper dimensions and border radius
                    'group-data-[collapsible=icon]:size-10 group-data-[collapsible=icon]:rounded-lg group-data-[collapsible=icon]:p-0',
                )}
            >
                {avatarUrl && failedSrc !== avatarUrl ? (
                    <img
                        src={avatarUrl}
                        alt={name}
                        className="h-full w-full object-contain"
                        onError={() => {
                            setFailedSrc(avatarUrl);
                        }}
                    />
                ) : (
                    <span className="text-foreground text-xs font-semibold select-none">{getInitials(name)}</span>
                )}
            </div>

            <div className="min-w-0 group-data-[collapsible=icon]:hidden">
                <p className="truncate text-sm font-bold" title={name}>
                    {name}
                </p>
                <p className="text-muted-foreground truncate text-xs" title={email}>
                    {email}
                </p>
            </div>
        </div>
    );
}
